// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wpcqJf1lxy644T {
  display: block;
  box-sizing: border-box;
  max-width: 500px;
  max-height: 500px;
  margin: var(--ds-space-100, 8px) var(--ds-space-0, 0) var(--ds-space-050, 4px);
  clear: both;
  border: 1px solid var(--ds-border, #091e4224);
  border-radius: var(--ds-border-radius-100, 3px);
}
.wpcqJf1lxy644T.rziydTsJ1ruIhT {
  max-width: 23%;
  max-height: 300px;
}
.card-back-redesign .wpcqJf1lxy644T {
  max-width: 100%;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"attachmentImagePreview": `wpcqJf1lxy644T`,
	"modCompactImagePreview": `rziydTsJ1ruIhT`
};
export default ___CSS_LOADER_EXPORT___;
